export default "__VITE_ASSET__D_MPA$_P__"